import { useContext, useEffect, useState, useRef } from "react";
import useApiPrivate from "../../../global/utils/hooks/useApiPrivate";
import { Row, Col, Table, Spinner, Input, Button } from "reactstrap";
import Breadcrumbs from "../../../global/Components/Breadcrumb/Breadcrumb";
import TransitionCard from "./Sections/TransitionCard";
import { useNavigate, useSearchParams } from "react-router-dom";
import { UserContext } from "../../../global/globalContext/context";
import { showMsg } from "../../../global/langs/langs";
import PaginationComponent from "../../../global/Components/Pagination/PaginationComponent";
import styles from './MyTransactions.module.scss';
import { Toast } from 'primereact/toast';

const FINANCES_URL = 'api/v1/finances';

export default function MyTransactions() {
  const apiPrivate = useApiPrivate();
  // const [searchParams, setSearchParams] = useSearchParams();
  const {lang} = useContext(UserContext);
  const navigate = useNavigate();
  const toast = useRef(null);


  const [isLoading, setIsLoading] = useState(false);
  const [finances, setFinances] = useState([]);
  const [metaData, setMetaData] = useState();
  const [currentPage, setCurrentPage] = useState();
  const [selectedPaymentType, setSelectedPaymentType] = useState('');

  const showSuccess = (message) => {
    toast.current.show({severity:'success', summary: 'Success', detail: message, life: 3000});
  }
  const showError = (message) => {
      toast.current.show({severity:'error', summary: 'Error', detail: message, life: 3000});
  }

  const handleChangePaymentType = (e) => {
    e.preventDefault();
    setSelectedPaymentType(e.target[e.target.selectedIndex].value);
  }

  const callFinances = async () => {
    setIsLoading(true);

    try {
      const response = await apiPrivate.get(FINANCES_URL, {
        params: {
          payment_type: selectedPaymentType && selectedPaymentType,
          page:currentPage && currentPage,
          limit: '',
        }
      });
      setFinances(response.data.data);
      setMetaData(response.data.meta);
      setCurrentPage(response.data.meta?.current_page);
      setIsLoading(false);
    }
    catch (error) {
      if (error?.response?.status === 400 || error?.response?.status === 401 || error?.response?.status === 422 || error?.response?.status === 429 || error?.response?.status === 500) {
        showError(error?.response?.data?.message);
      } 
      setIsLoading(false);
    }
  }

  useEffect(() => {
    callFinances();
  }, []);

  useEffect(() => {
    // currentPage &&
    //   searchParams.set('page', currentPage);
    //   setSearchParams(searchParams);
      callFinances();
  },[currentPage, selectedPaymentType]);

  return (
    <>
      <Toast ref={toast} position="top-center" />

      <Row>
        <Col sm={8} md={8}>
          <Breadcrumbs />
        </Col>
        <Col sm={4} md={4}>
          <div className={`text-end fsSmall`}>
            {
            metaData ? (
              <>
                  {metaData.total}
                  <span>
                    {' '}{showMsg('results', lang)}
                  </span>
              </>
            ) : (
              <span>
                {showMsg('no_results', lang)}
              </span>
            )
            }
          </div>
        </Col>
      </Row>
      <Row>
        <Col>
          <div className={`bg-white lgtBackground p-4`} >
            <Row>
              <Col xs={7}>
                <div>
                  <Input 
                    id={'payment-type'} 
                    name='payment_type'
                    className="mb-3"
                    value={selectedPaymentType}
                    type='select' 
                    placeholder='Choose ...' 
                    onChange={(e) => handleChangePaymentType(e)}
                    >
                    <option value="">
                      All payment...
                    </option>
                    <option id={'LISTING'} value={'LISTING'} >
                      LISTING
                    </option>
                    <option id={'ADVERTISE'} value={'ADVERTISE'} >
                      ADVERTISE
                    </option>
                    <option id={'Commission'} value={'Commission'} >
                      Commission
                    </option>
                    <option id={'CHARGE'} value={'CHARGE'} >
                      CHARGE
                    </option>
                  </Input>
                </div>
              </Col>
              {/* <Col sm={12} md={3}></Col> */}
              {/* <Col sm={12} md={3}></Col> */}
              <Col xs={5}>
                <div className="text-end">
                  <Button 
                    className="general-button"
                    onClick={() => navigate(`/dashboard/charge`)}>
                    Charge
                  </Button>
                </div>
              </Col>
            </Row>
            {isLoading
              ? <div className="d-flex justify-content-center mb-3">
                  <Spinner color='primary' className="tetx-center">
                    Loading...
                  </Spinner>
                </div>
            : <Table striped responsive className={`${styles.finance}`}>
                <thead>
                  <tr className="border-bottom">
                    <th>Date</th>
                    <th>Description</th>
                    <th>Credit</th>
                    <th>Debit</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {finances.length > 0 
                    ? finances.map((finance) => (
                        <TransitionCard key={finance.id} finance={finance} />
                      ))
                    : <tr>
                        <td colSpan={5}>
                          <p className="fw-bold py-4 ps-3">
                            No transactions to display
                          </p>
                        </td>
                      </tr>
                  }
                </tbody>
              </Table>
            }
            {
            metaData &&
              metaData.last_page > 1 
                ? (
                  <PaginationComponent currentPage={currentPage} setCurrentPage={setCurrentPage}  metaData={metaData}/>
                ) 
                : ('')
            }    
          </div>
        </Col>
      </Row>
    </>
  )
}
